var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 214.83 172.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#Gradiente_sem_nome_2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill-opacity: 0.5;\r\n        fill: url(#Gradiente_sem_nome_3);\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: 0.89;\r\n        fill: url(#Gradiente_sem_nome_4);\r\n      }\r\n\r\n      .cls-10, .cls-11, .cls-12, .cls-3, .cls-6 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Gradiente_sem_nome_10);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#Gradiente_sem_nome_10-2);\r\n      }\r\n\r\n      .cls-6 {\r\n        opacity: 0.39;\r\n        fill: url(#Gradiente_sem_nome_7);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#Gradiente_sem_nome_10-3);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#Gradiente_sem_nome_10-4);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#Gradiente_sem_nome_10-5);\r\n      }\r\n\r\n      .cls-10 {\r\n        opacity: 0.5;\r\n        fill: url(#Gradiente_sem_nome_12);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #ad2a81;\r\n        opacity: 0.25;\r\n      }\r\n\r\n      .cls-12 {\r\n        opacity: 0.3;\r\n        fill: url(#Gradiente_sem_nome_12-2);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradiente_sem_nome_2",
    "data-name": "Gradiente sem nome 2",
    cx: -92.16,
    cy: 253.93,
    r: 1,
    gradientTransform: "matrix(102.97, 0, 0, -103.14, 9576.65, 26237.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2cf5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#aacc65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6fbd8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006dad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    "data-name": "Gradiente sem nome 3",
    x1: 81.15,
    y1: 234.55,
    x2: 81.15,
    y2: 140.8,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 234.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0f7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0f7c5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    "data-name": "Gradiente sem nome 4",
    x1: 55.83,
    y1: 213.57,
    x2: 187.4,
    y2: 110.53,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 234.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#067662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a6c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_10",
    "data-name": "Gradiente sem nome 10",
    x1: -41.74,
    y1: 157.32,
    x2: 135.65,
    y2: 13.92,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 234.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2661f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#cc3327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d1768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_10-2",
    x1: -11.46,
    y1: 194.77,
    x2: 165.93,
    y2: 51.37,
    xlinkHref: "#Gradiente_sem_nome_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7",
    "data-name": "Gradiente sem nome 7",
    x1: 11.48,
    y1: 62.16,
    x2: 14.44,
    y2: 62.16,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 234.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59bba9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_10-3",
    x1: 12.07,
    y1: 233.02,
    x2: 189.46,
    y2: 89.61,
    xlinkHref: "#Gradiente_sem_nome_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_10-4",
    x1: 32.97,
    y1: 152.77,
    x2: 258.69,
    y2: 135.79,
    xlinkHref: "#Gradiente_sem_nome_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_10-5",
    x1: 18.57,
    y1: 131.24,
    x2: 196.71,
    y2: 129.86,
    xlinkHref: "#Gradiente_sem_nome_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12",
    "data-name": "Gradiente sem nome 12",
    x1: 6.98,
    y1: 134.91,
    x2: 89.66,
    y2: 126.22,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 234.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61bdab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-2",
    x1: 68.45,
    y1: 238.95,
    x2: 107.41,
    y2: 154.95,
    xlinkHref: "#Gradiente_sem_nome_12"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.18,95.92l-18-.27L93.4,94.91,64.73,94.5l-9-.13V90.26c.07-2,.14-4.78.27-7.93,0-.28.07-.61.07-.88,1.2-21.32,6.85-62.89,32-76.81h.07A39.13,39.13,0,0,1,106.56,0H107a36,36,0,0,1,10.88,1.55c30.08,9.21,40.49,56.9,43.85,80.78.4,2.68.67,5.1.87,7.13v.06c.2,1.75.34,3.16.47,4.23C163.11,95.18,163.18,95.92,163.18,95.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.73,83.46v2.09L58,84.93c-.5-11.81,3.1-37,7.5-47C71,25.43,76.12,5.57,106.56,0A39.13,39.13,0,0,0,88.1,4.64H88c-25.11,13.92-30.76,55.49-32,76.81,0,.27-.07.6-.07.87-.13,3.16-.2-2.9-.27-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.18,95.92l-18-.27L93.4,94.91,64.73,94.5l-8-2.28-1-.27V90.27c.06-2,.13-4.78.26-7.94,0-.27.07-.6.07-.87,29.55-.14,66.27-2.56,76.89-13.18C159,42.18,139,2.1,107,0a35.69,35.69,0,0,1,10.88,1.55c30.08,9.21,40.49,56.9,43.85,80.77.41,2.69.67,5.11.87,7.13v.07c.2,1.75.34,3.16.47,4.23C163.11,95.18,163.18,95.92,163.18,95.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.45,118.52l-56,37.53L18,172.46l-3.3.06h-3l-.2-.27L0,153.89l39.42-30,6.91-5.32.61-.47,25.78-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.29,116.7l-.27,1.41-.07.41-8.86,47.88-.81,4.38-19.87.33L93,125.78h-.08l-.19-1-1.28-6.25-.07-.34-.13-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.44,172.52H11.68l-.2-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M214.83,148.86,204,167.56l-.19.34-2.69.06h-.27l-3.29.08,2-16.49L177.9,138.17l-37-23,25.72-.47,7.72,5.44.74.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.06,82.33v7.13l-2.49.07L56.74,92.22l-1,.07-6,.13L50,90.34l.82-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.07,118.52H30.69l12-28.12L50,90.34l5.78-.07,106.84-.81h2.49l8-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.73,94.41l-9,20.07H67.79L71.43,94.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M145,94.41l3,21.08h33.08l-9-22.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.58,37.05C98.15,49,89.81,57.4,81.94,55.8S69.65,43.21,72.08,31.25,82.85,10.9,90.73,12.5,103,25.1,100.58,37.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M87.24,23.94c-1.07,2.8-3.43,4.49-5.26,3.78s-2.47-3.55-1.39-6.34S84,16.89,85.86,17.6,88.32,21.14,87.24,23.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M81.31,33.27c-.41,1.07-1.3,1.71-2,1.44s-.94-1.35-.54-2.41,1.31-1.71,2-1.44S81.71,32.21,81.31,33.27Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNave);
export default __webpack_public_path__ + "static/media/nave.de9d7b0e5ec884cf4dfbb220c4c7b7bf.svg";
export { ForwardRef as ReactComponent };